import { render, staticRenderFns } from "./App.vue?vue&type=template&id=859315ae&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\MidwestBeltone.Iframes.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('859315ae')) {
      api.createRecord('859315ae', component.options)
    } else {
      api.reload('859315ae', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=859315ae&", function () {
      api.rerender('859315ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/App.vue"
export default component.exports